export default "__VITE_PUBLIC_ASSET__921f6f50__"